import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CloudUrlStatus from './CloudUrlStatus';

import { kgASTVersions } from '../AMRPredictions/kgASTVersionReference';

const styles = {
  container: {
    p: 2,
  },
  metaInfo: {
    mb: 2,
  },
  divider: {
    my: 2,
  },
  timestamp: {
    color: 'text.secondary',
    fontSize: 'small',
    display: 'block',
  }
};

function KeynomeCloudStatusDetails({ currentStableRelease }) {
  const kgASTVersion = 'v0.7.7.0';
  const stableReleaseLabel = currentStableRelease
  ? currentStableRelease.replace(/ont-|illumina-/gi, '')
  : '...';

  return (
    <Box sx={styles.container}>
      <Stack spacing={2}>
        <CloudUrlStatus url={process.env.REACT_APP_KEYNOME_API_URL_BASE}/>
        <CloudUrlStatus url={process.env.REACT_APP_KEYNOME_AUTH0_DOMAIN}/>

        <Box>
          <Typography>
            <Box component="span" fontWeight="bold">Current Stable Release:</Box>{' '}
            {stableReleaseLabel}
          </Typography>
          <Box sx={{ ml: 2, mt: 1 }}>
            <Typography>
              Cepheid SeqID: v3.0{' '}
              <Typography component="span" sx={styles.timestamp}>
                (Cepheid SeqID DB v2.2.1)
              </Typography>
            </Typography>
            <Typography sx={{ mt: 0.5 }}>
              Cepheid gAST: {kgASTVersion}{' '}
              <Typography component="span" sx={styles.timestamp}>
                (Cepheid gAST DB {kgASTVersions[kgASTVersion].microhmDBVersion} / {kgASTVersions[kgASTVersion].clsiVersion})
              </Typography>
            </Typography>
          </Box>
        </Box>
        
      </Stack>
    </Box>
  );
}

export default KeynomeCloudStatusDetails;
